import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Grid, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
    BOOLEAN_FIELD_TYPE,
    DATE_FIELD_TYPE,
    SELECT_FIELD_TYPE,
    TEXT_FIELD_TYPE,
} from "../../helpers/constants";

export const NOTIFICATION_DRAFTS_TABLE_NAME = "notification_drafts_table";

export const useNotificationDraftsTableFieldsConfig = () => {
    const { t } = useTranslation();

    const boolToString = (value) => (value ? t("yes") : t("no"));

    const languageOptions = [
        { value: "polski", label: t("drafts.languages.polish") },
        { value: "angielski", label: t("drafts.languages.english") },
    ];

    return [
        // {
        //     name: "template_number",
        //     getValueCallback: (rowData) => (
        //         <Grid
        //             item
        //             sx={{
        //                 minHeight: 40,
        //                 display: "flex",
        //                 alignItems: "center",
        //                 justifyContent: "center",
        //             }}
        //         >
        //             {rowData.template_number}
        //         </Grid>
        //     ),
        //     label: t("drafts.columns.templateNumber"),
        //     filterType: TEXT_FIELD_TYPE,
        //     getFilterFieldConfigCallback: (filteringData) => undefined,
        //     sortable: true,
        //     minWidth: 120,
        //     width: 120,
        // },
        {
            name: "template_name",
            getValueCallback: (rowData) => rowData.template_name,
            label: t("drafts.columns.templateName"),
            filterType: TEXT_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => undefined,
            sortable: true,
            minWidth: 180,
            width: 180,
        },
        {
            name: "draft_notification",
            getValueCallback: (rowData) => rowData.draft_notification,
            label: t("drafts.columns.notificationType"),
            filterType: TEXT_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => undefined,
            sortable: true,
            minWidth: 180,
            width: 180,
        },
        // {
        //     name: "description",
        //     getValueCallback: (rowData) => rowData.description || "-",
        //     label: t("drafts.columns.description"),
        //     filterType: TEXT_FIELD_TYPE,
        //     getFilterFieldConfigCallback: (filteringData) => undefined,
        //     sortable: false,
        //     minWidth: 200,
        //     width: 200,
        // },
        {
            name: "active",
            getValueCallback: (rowData) => boolToString(rowData.active),
            label: t("drafts.columns.active"),
            filterType: BOOLEAN_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => undefined,
            sortable: true,
            minWidth: 100,
            width: 100,
        },
        {
            name: "creation_date",
            getValueCallback: (rowData) => {
                const date = new Date(rowData.creation_date);
                return date.toLocaleDateString();
            },
            label: t("drafts.columns.creationDate"),
            filterType: DATE_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => undefined,
            sortable: true,
            minWidth: 120,
            width: 120,
        },
        {
            name: "language",
            getValueCallback: (rowData) => rowData.language,
            label: t("drafts.columns.language"),
            filterType: SELECT_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => ({
                optionKey: "value",
                optionLabel: "label",
                options: languageOptions,
            }),
            fieldConfig: {
                optionKey: "value",
                optionLabel: "label",
                options: languageOptions,
            },
            sortable: true,
            minWidth: 100,
            width: 100,
        },
        {
            name: "edit_button",
            getValueCallback: (rowData, onClickButton) => (
                <IconButton
                    color={"primary"}
                    onClick={(e) => onClickButton?.(e, rowData.id, "edit")}
                >
                    <EditIcon />
                </IconButton>
            ),
            label: t("edit"),
            sortable: false,
            minWidth: 80,
            width: 80,
            allowChangeVisibility: false,
            excludedFromExport: true,
        },
        {
            name: "delete_button",
            getValueCallback: (rowData, onClickButton) => (
                <IconButton
                    color={"error"}
                    onClick={(e) => onClickButton?.(e, rowData.id, "delete")}
                >
                    <DeleteIcon />
                </IconButton>
            ),
            label: t("delete"),
            sortable: false,
            minWidth: 80,
            width: 80,
            allowChangeVisibility: false,
            excludedFromExport: true,
        },
    ];
};
